<template>
  <div id="SSS" class="EchartS1">
    <div id="main" style="height:100%"></div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';

export default {
  data() {
    return {
      // 需要合并对象，样式
      options: {},
      data: [
        {
          value: ['1997-10-1 00:10:10', 684]
        },
        {
          value: ['1997-10-1 00:41:10', 200]
        },
        {
          value: ['1997-10-1 00:44:10', 300]
        },
        {
          value: ['1997-10-1 00:44:10', '-']
        },
        {
          value: ['1997-10-1 00:46:10', '-']
        },
        {
          value: ['1997-10-1 01:48:10', '-']
        }
      ]
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
    var myChart = echarts.init(document.getElementById('main'));

    var option = {
      title: {
        text: '功率桑吉图',
        textStyle: { color: '#fff' },

        x: 'center'
      },
      series: {
        type: 'sankey',
        layout: 'none',
        label: {
          normal: { color: '#fff' }
        },
        data: [
          {
            name: '总功率'
          },
          {
            name: '彼欧'
          },
          {
            name: '内饰'
          },
          {
            name: '座椅'
          },
          {
            name: '彼欧工厂1'
          },
          {
            name: '彼欧工厂2'
          },
          {
            name: '彼欧工厂3'
          },
          {
            name: '内饰金桥'
          },
          {
            name: '内饰安亭'
          },
          {
            name: '内饰沈阳'
          },
          {
            name: '座椅工厂1'
          },
          {
            name: '座椅工厂2'
          },
          {
            name: '座椅工厂3'
          }
        ],
        links: [
          {
            source: '总功率',
            target: '彼欧',
            value: 15
          },
          {
            source: '总功率',
            target: '内饰',
            value: 15
          },
          {
            source: '总功率',
            target: '座椅',
            value: 15
          },
          {
            source: '彼欧',
            target: '彼欧工厂1',
            value: 5
          },
          {
            source: '彼欧',
            target: '彼欧工厂2',
            value: 5
          },
          {
            source: '彼欧',
            target: '彼欧工厂3',
            value: 5
          },
          {
            source: '内饰',
            target: '内饰金桥',
            value: 5
          },
          {
            source: '内饰',
            target: '内饰安亭',
            value: 5
          },
          {
            source: '内饰',
            target: '内饰沈阳',
            value: 5
          },
          {
            source: '座椅',
            target: '座椅工厂1',
            value: 5
          },
          {
            source: '座椅',
            target: '座椅工厂2',
            value: 5
          },
          {
            source: '座椅',
            target: '座椅工厂3',
            value: 5
          }
        ]
      }
    };

    // 5：展示数据
    myChart.setOption(option);
  }
};
</script>
<style lang="less">
.EchartS1 {
  position: relative;
  width: 70%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
}
</style>
